import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import * as Sentry from '@sentry/react';
import './i18n';

Sentry.init({
  dsn: 'https://987d42b1c2ff9f225380cfc557e3a8b7@o109274.ingest.us.sentry.io/4507091129008128',
  integrations: [],
  environment: process.env.REACT_APP_ENV || 'development',
  enabled: ['sandbox', 'staging', 'production'].includes(
    process.env.REACT_APP_ENV as string
  ),
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
